const nameSeparators = /([\s\-\u2010-\u2015'\u2019]+)/;

export const toInitCap = (value: string = "") =>
  value
    .toLocaleLowerCase("lv-LV")
    .split(nameSeparators)
    .map((part, index) =>
      index % 2 === 0 && part.length > 0
        ? part.charAt(0).toLocaleUpperCase("lv-LV") + part.slice(1)
        : part
    )
    .join("");
